import { routesMonitoringRootStore } from '../../routes-monitoring-screen/stores/routes-monitoring-root-store';
import { View } from '../types';
import { orderExplorerRootStore } from '../../order-explorer/stores/order-explorer-root-store';

export const useSelectedColor = (
	view: View
): {
	color: string;
} => {
	const getColor = (): string | undefined => {
		if (view === 'routes') {
			return routesMonitoringRootStore.getStore().routesMonitoringViewStore.selectedColor;
		} else {
			return orderExplorerRootStore.getStore().orderExplorerStore.selectedActionColor;
		}
	};

	return {
		color: getColor()
	};
};
